import { render, staticRenderFns } from "./ttzTable.vue?vue&type=template&id=910761c0&scoped=true"
import script from "./ttzTable.vue?vue&type=script&lang=ts"
export * from "./ttzTable.vue?vue&type=script&lang=ts"
import style0 from "./ttzTable.vue?vue&type=style&index=0&id=910761c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910761c0",
  null
  
)

export default component.exports